import BusinessInformationConversation from '../pages/BusinessInformationConversation.vue';

const businessInformationConversationRoutes = [
  {
    path: '/business-information-conversation/:id',
    name: 'اطلاعات کسب و کار/ارسال پیام به ادمین',
    component: BusinessInformationConversation,
  },
 
];

export default businessInformationConversationRoutes;